import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

export const Route = createFileRoute("/plugin/figma/intro")({
  component: Intro,
});

function Intro() {
  const navigate = useNavigate();

  return (
    <div className="w-full p-8">
      <CardContent>
        <Carousel className="">
          <CarouselContent>
            {Array.from({ length: 5 }).map((_, index) => (
              <CarouselItem key={index}>
                <div className="p-1">
                  <Card>
                    <CardContent className="flex aspect-square items-center justify-center p-6">
                      <span className="text-4xl font-semibold">{index + 1}</span>
                    </CardContent>
                  </Card>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      </CardContent>
      <CardFooter className="flex">
        <Button
          className="mx-auto"
          onClick={() => {
            navigate({ to: "/plugin/figma/sign-up", replace: true });
          }}
        >
          Create account
        </Button>
      </CardFooter>
    </div>
  );
}
